var _defs, _path, _ellipse, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoapRollDispenserOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216.26 327.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke-width: 2px;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-4 {\r\n        stroke: #000;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #c46300;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #ff8100;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M34,111.43s-1.12,78.73,3.35,91.91c4.46,13.14,10.03,39.4,10.05,51.01,0,.06,0,.1.02.16.35,1.68,6.48,30.81,10.01,37.78.02.04.04.08.05.13l10.68,34.45c.24.79,1.22.77,1.44-.03l1.39-5.01c.09-.34.36-.58.67-.61l6.4-.55c.37-.03.66-.36.7-.78l.75-8.35c.01-.16.07-.31.15-.43l1.39-2.13c.1-.16.16-.36.15-.56l-.26-7.66c0-.24.07-.48.22-.65l4.58-5.27c.13-.15.21-.36.22-.58l.24-6.43c.01-.37.23-.7.54-.8l3.33-1.13c.46-.16.68-.76.46-1.24-1.71-3.72-7.88-17.64-9.33-27.31,0-.02,0-.04,0-.06-.1-1.04-2.9-28.46-8.38-55.88l-4.18-22.78s0-.05-.01-.08l-.5-21.78c-.06-.14-.15-.36-.29-.59-.59-.98-1.44-1.41-1.93-1.69-.07-.04-.86-.75-2.44-2.17-2.1-1.89-4.55-4.26-5.38-5.09-4.94-4.91-10.54-12.61-11.65-14.12-3.7-5.08-6.31-8.7-9.1-14.18-1.54-3.03-2.63-5.65-3.35-7.49Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 108.3,
    cy: 108.84,
    rx: 74.09,
    ry: 74.61
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 108.3,
    cy: 109.97,
    r: 34.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.71,89.49h7.3v40.96h-7.17s-.46-41.28-.13-40.96Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoapRollDispenserOrange);
export default __webpack_public_path__ + "static/media/soap_roll_dispenser_orange.8d39d1b1aed527c9af34e5af10d4e8de.svg";
export { ForwardRef as ReactComponent };